export const BONUS_RECORD_STATUSES = [
  { value: 'all', label: 'Все' },
  { value: 'received', label: 'Данные получены' },
  { value: 'sent', label: 'Данные отправлены в МПШ' },
  { value: 'success', label: 'Получен ответ от МПШ: успешно' },
  { value: 'error', label: 'Получен ответ от МПШ: ошибка' },
  { value: 'canceled', label: 'Отменена' },
];
